import { render, staticRenderFns } from "./PlayerControl.vue?vue&type=template&id=f3036c0a&"
import script from "./PlayerControl.vue?vue&type=script&lang=js&"
export * from "./PlayerControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports